export const Z_INDEX = {
  navigation: 1000,
  toast: 1100,
}
